/* eslint-disable no-unused-vars */
import BackgroundService from "@/services/background";

import { SET_SCRIPTS, SET_JOBS, SET_TASKS } from "./types";

export async function fetchScripts({commit}) {
  const {data} = await BackgroundService.getScripts();
  commit(SET_SCRIPTS, data.data);
  return data;
}

export async function createJob({commit}, params) {
  const {data} = await BackgroundService.createJob(params);
  return data;
}

export async function fetchJobById({commit}, id) {
  const {data} = await BackgroundService.getById(id);
  const job = data.data.job;
  return job;
}

export async function updateJob({commit}, {params, id}) {
  const {data} = await BackgroundService.updateJob(id, params);
  return data;
}

export async function fetchJobs({commit}) {
  const {data} = await BackgroundService.get();
  const jobs = data.data.jobs;
  commit(SET_JOBS, jobs);
  return data;
}

export async function deleteJobs({commit}, params) {
  const {data} = await BackgroundService.delete(params);
  return data;
}

export async function makeTodo({commit}, params) {
  const {data} = await BackgroundService.makeTodo(params);
  return data;
}

export async function fetchTasks({commit}, {id, params}) {
  const {data} = await BackgroundService.getTaskById(id, params);
  const tasks = data.data.tasks;
  commit(SET_TASKS, tasks);
  return data;
}

export async function addTasks({commit}, {id, params}) {
  const {data} = await BackgroundService.addTasks(id, params);
  return data;
}